import assessmentReviews from "./assessmentReviews";
import config from "../../conf/config";

const assessmentReviewMeetingService = [
    {
        matcher: 'assessmentReviewMeeting/assessmentReviews',
        reply: config => {
            const {predicate} = config.params;
            let data;
            if(predicate?.node()?.selector?.()==='projectManager') {
                const projectManager = predicate.node().expectation();
                const regexp = new RegExp(projectManager.replaceAll('*', '.*'));
                data = assessmentReviews.filter(assessmentReview => regexp.test(assessmentReview.projectManager));
            } else {
                data = assessmentReviews;
            }

            return [200, data]
        }
    },
    {
        matcher: /assessmentReviewMeeting\/assessmentReviews\/(.*)/,
        reply: config => {
            const id = /assessmentReviewMeeting\/assessmentReviews\/(.*)/.exec(config.url)[1];
            const data = assessmentReviews.find(assessmentReview => assessmentReview.uuid === id);
            return [200, data];
        }
    },
    {
        matcher: 'assessmentReviewMeeting/getProjectManagers',
        reply: config => {
            const data = [];
            assessmentReviews.forEach((assessmentReview) => {
                if(!data.find(data => data === assessmentReview.projectManager)){
                    data.push(assessmentReview.projectManager);
                }
            })
            return [200, data];
        }
    }
]

export default assessmentReviewMeetingService;